/* eslint no-underscore-dangle: 0 */
import { SERVICE_ACTIVATION_PRODUCT_STATUSES } from 'features/order-tracker/utils/entries';

export const APPOINTMENT_AWAITING_CONFIRMATION = 'Awaiting confirmation, your requested date: ';
export const APPOINTMENT_SCHEDULED_DATE = 'Scheduled date: ';
export const APPOINTMENT_ENGINEER_UNABLE_TO_COMPLETE = 'Engineer unable to complete job scheduled for: ';
export const APPOINTMENT_SUPPLIER_DELAYED = 'Our supplier was unable to complete your installation scheduled for: ';
export const APPOINTMENT_TOOK_PLACE = 'Your appointment took place on: ';
export const APPOINTMENT_SUPPLIER_WAS_UNABLE_TO_ATTEND =
  'Our supplier was unable to attend your appointment scheduled for: ';
export const DELIVERY_EXPECTED = 'Expected: ';
export const DELIVERY_DELIVERED = 'Delivered: ';
export const DELIVERY_DETAILS_FAILED_INFO = {
  title: 'Need your delivery details now?',
  text: ['We’re happy to help. Please contact us on ', 'live chat', ' or '],
};

export const SERVICE_ACTIVATION_MESSAGE = {
  [SERVICE_ACTIVATION_PRODUCT_STATUSES.BBAndCVEIncomplete]:
    'Your broadband and digital phone line are scheduled to go live on ',
  [SERVICE_ACTIVATION_PRODUCT_STATUSES.BBAndCVECompleted]: 'Your broadband and digital phone line went live on ',
  [SERVICE_ACTIVATION_PRODUCT_STATUSES.BBProductIncomplete]: 'Your broadband is scheduled to go live on ',
  [SERVICE_ACTIVATION_PRODUCT_STATUSES.BBProductCompleted]: 'Your broadband went live on ',
  [SERVICE_ACTIVATION_PRODUCT_STATUSES.CVEProductIncomplete]: 'Your digital phone line is scheduled to go live on ',
  [SERVICE_ACTIVATION_PRODUCT_STATUSES.CVEProductCompleted]: 'Your digital phone line went live on ',

  [SERVICE_ACTIVATION_PRODUCT_STATUSES.BBAppointmentAndCVEIncomplete]:
    'Your broadband and digital phone line will go live on the same day your engineer appointment is completed. This is scheduled for ',
  [SERVICE_ACTIVATION_PRODUCT_STATUSES.BBAppointmentAndCVECompleted]:
    'Your broadband and digital phone line went live on ',

  [SERVICE_ACTIVATION_PRODUCT_STATUSES.BBAppointmentIncomplete]:
    'Your broadband will go live on the same day your engineer appointment is completed. This is scheduled for ',

  [SERVICE_ACTIVATION_PRODUCT_STATUSES.BBAppointmentCompleted]: 'Your broadband went live on ',
  [SERVICE_ACTIVATION_PRODUCT_STATUSES.nonHaloIncomplete]: [
    'Your order is on track and should be completed by ',
    'If the date changes, we’ll let you know in advance.',
  ],
  [SERVICE_ACTIVATION_PRODUCT_STATUSES.nonHaloCompleted]: 'Your order was completed on ',

  common: 'For help installing your equipment have a look at our ',
};

export const _SERVICE_ACTIVATION_MESSAGE_ = {
  [SERVICE_ACTIVATION_PRODUCT_STATUSES.BBProductIncomplete]:
    'Your broadband service will go live on the scheduled date.',
  [SERVICE_ACTIVATION_PRODUCT_STATUSES.BBAppointmentCompleted]: 'Learn more about using your new broadband service in ',
  [SERVICE_ACTIVATION_PRODUCT_STATUSES.CVEProductIncomplete]: ' ',
  [SERVICE_ACTIVATION_PRODUCT_STATUSES.CVEProductCompleted]:
    'Learn more about using your new Cloud Voice Express service in ',
  [SERVICE_ACTIVATION_PRODUCT_STATUSES.BBAndCVEIncomplete]:
    'Your broadband service will go live on the scheduled date.',
  [SERVICE_ACTIVATION_PRODUCT_STATUSES.BBAndCVECompleted]: 'Learn more about using your new broadband service',

  [SERVICE_ACTIVATION_PRODUCT_STATUSES.BBAppointmentIncomplete]:
    'Your broadband service will go live on the scheduled date.',
  [SERVICE_ACTIVATION_PRODUCT_STATUSES.nonHaloIncomplete]: [],
  [SERVICE_ACTIVATION_PRODUCT_STATUSES.BBAppointmentAndCVEIncomplete]:'Your broadband service will go live on the scheduled date.',

  [SERVICE_ACTIVATION_PRODUCT_STATUSES.nonHaloCompleted]: 'Learn more about using your new broadband service in ',
  [SERVICE_ACTIVATION_PRODUCT_STATUSES.BBAccessCompleted]: 'Learn more about using your new broadband service in ',
  BBCompleted: 'Learn more about using your new broadband service in ',
  CVECompleted: 'Learn more about using your new Cloud Voice Express service in ',
  common: '',
};

export const BY_PHONE_LINK_TEXT = 'by phone';
export const BY_PHONE_LINK_URL = 'https://business.bt.com/help/contact-us-business/';
export const SETUP_GUIDE_LINK_URL =
  'https://business.bt.com/help/guides/getting-started-with-your-bt-business-products/';
export const SETUP_GUIDE_LINK_TEXT = 'our handy help guides.';
export const SETUP_GUIDE_LINK_ANALYTICS = 'Service activation - Setup guides';
